import ScrollView from 'devextreme-react/scroll-view';

export function OffboardingHistoryPage() {
  return (
    <ScrollView>
      <div style={{ padding: '1rem 1.25rem' }}>
        <h2>Offboarding History</h2>
        <p>Completed and in-progress offboarding records will live here.</p>
      </div>
    </ScrollView>
  );
}
